import type {DayHoursByProject} from '@app/api-resolver/router'

export const mapHighlights = (dayHoursByProject: DayHoursByProject[]) => {
  const totalHours = dayHoursByProject.length > 0 ? dayHoursByProject.reduce((sum, data) => sum + data.hours, 0) : null
  const totalDays = dayHoursByProject.length > 0 ? new Set(dayHoursByProject.map((data) => data.dayStart)).size : null

  return {totalHours, totalDays}
}
